if (!window.customCardProductSliderInitialized) {
  window.customCardProductSliderInitialized = true;

  // ── Mobile video autoplay via IntersectionObserver ──────────────────────
  // Mobile browsers (iOS Safari, Android Chrome) block the HTML autoplay
  // attribute. We must call .play() programmatically once the video is
  // visible in the viewport. We also pause when it scrolls out.
  function initVideoAutoplay() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just try playing all videos immediately
      document.querySelectorAll('.card__media-slide video').forEach(function(v) {
        v.muted = true;
        v.play().catch(function() {});
      });
      return;
    }

    const videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.muted = true; // ensure muted (required for autoplay on mobile)
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.3 }); // play when 30% of the video is visible

    document.querySelectorAll('.card__media-slide video').forEach(function(video) {
      videoObserver.observe(video);
    });
  }

  // Run on DOMContentLoaded and also observe dynamically added cards
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoAutoplay);
  } else {
    initVideoAutoplay();
  }

  // Re-observe videos added later (e.g. via lazy section loading)
  if ('MutationObserver' in window) {
    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            const videos = node.querySelectorAll
              ? node.querySelectorAll('.card__media-slide video')
              : [];
            if (videos.length) initVideoAutoplay();
            // Also check if the node itself is a video slide
            if (node.matches && node.matches('.card__media-slide video')) {
              initVideoAutoplay();
            }
          }
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  // An event target is not always an Element: capture-phase scroll fires with
  // e.target === document, and touch/SVG targets can be text or shadow nodes.
  // None of those have .closest, so resolve to the nearest Element first.
  function closestFromEvent(target, selector) {
    const el = target instanceof Element ? target : target && target.parentElement;
    return el ? el.closest(selector) : null;
  }

  // ── Pause/play videos when slider is scrolled between slides ────────────
  document.addEventListener('scroll', function(e) {
    const slider = closestFromEvent(e.target, '.card__media-slider');
    if (!slider) return;

    const index = Math.round(slider.scrollLeft / slider.clientWidth);
    const inner = slider.closest('.card__inner');
    if (!inner) return;

    // Update active dot indicator
    const dotsContainer = inner.querySelector('.card__media-dots');
    if (dotsContainer) {
      const dots = dotsContainer.querySelectorAll('.card__media-dot');
      dots.forEach(function(dot, idx) {
        dot.classList.toggle('active', idx === index);
      });
    }

    // Play the video on the active slide, pause others
    const slides = slider.querySelectorAll('.card__media-slide');
    slides.forEach(function(slide, idx) {
      const video = slide.querySelector('video');
      if (!video) return;
      if (idx === index) {
        video.muted = true;
        video.play().catch(function() {});
      } else {
        video.pause();
      }
    });
  }, true);

  // Handle click events on navigation arrows and pagination dots
  document.addEventListener('click', function(e) {
    const arrow = closestFromEvent(e.target, '.card__media-arrow');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();

      const inner = arrow.closest('.card__inner');
      const slider = inner && inner.querySelector('.card__media-slider');
      if (!slider) return;

      const isNext = arrow.classList.contains('card__media-arrow--next');
      const scrollAmount = slider.clientWidth;

      slider.scrollBy({
        left: isNext ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
      return;
    }

    const dot = closestFromEvent(e.target, '.card__media-dot');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();

      const index = parseInt(dot.getAttribute('data-index'), 10);
      const inner = dot.closest('.card__inner');
      const slider = inner && inner.querySelector('.card__media-slider');
      if (!slider) return;

      slider.scrollTo({
        left: slider.clientWidth * index,
        behavior: 'smooth'
      });
    }
  });
}
// document.querySelectorAll('.card__media-arrow--next').forEach(btn => {
//   btn.onclick = function() {
//     const slider =
//       this.closest('.card__inner')
//           .querySelector('.card__media-slider');

//     slider.scrollBy({
//       left: slider.clientWidth,
//       behavior: 'smooth'
//     });
//   };
// });